import { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import {GuestChatBase} from './components/GuestChatBase'
import {PrivateLayout} from '../../layouts/ChatLayout'
import {ChatProvider} from '../../context/chat/Context'
import { authAPI } from '../../api'
import { useAuth } from '../../context/auth'
import { useChat } from '../../context/chat/Context'
import { setCurrentChat, setChats } from '../../context/chat'
import { SplashLogo } from '../../components/Logo'
import { useIntl } from 'react-intl'
import toastr from 'toastr';


const GuestChatRoutes = () => {
  const { currentUser } = useAuth()
  const { dispatch } = useChat()

  useEffect(() => {
    if (currentUser?.chat_id) {
      dispatch(setCurrentChat(currentUser.chat_id))
    }
  }, [currentUser?.chat_id, dispatch])

  return (
    <Routes>
      <Route element={<PrivateLayout />}>
        <Route path="/" element={<GuestChatBase />} />
      </Route>
    </Routes>
  )
}


export const GuestSessionInit = ({ children }) => {
  const { setCurrentUser } = useAuth()
  const intl = useIntl()
  const { dispatch } = useChat()

  const [showSplashScreen, setShowSplashScreen] = useState(true)

  useEffect(() => {
    const getSession = async () => {
      try {
        const { data: session } = await authAPI.getGuestSession()
        setCurrentUser({ settings: session["data"]["settings"] })
        dispatch(setChats([{"id":session["data"]["chat_id"]}]))
        dispatch(setCurrentChat(session["data"]["chat_id"]))
      } catch (error) {
        if ((error as any).response?.status === 429) {
          toastr.info(intl.formatMessage({id: `chat.guest_chat_session_exceeded`}))
        }
      } finally {
        setShowSplashScreen(false)
      }
    }
    setShowSplashScreen(true)
    getSession()
  }, [dispatch])

  return showSplashScreen ? <SplashLogo/> : <>{children}</>
}

const GuestChatPage = () => { 
  return (
    <ChatProvider>
      <GuestSessionInit>
        <GuestChatRoutes />
      </GuestSessionInit>
    </ChatProvider>
  )
}

export default GuestChatPage
